import { createFileRoute } from "@tanstack/react-router";
import ExecutiveCantAffordSixWeeks from "@/pages/articles/ExecutiveCantAffordSixWeeks";
export const Route = createFileRoute(
  "/the-executive-who-cant-afford-six-weeks",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "The Executive Who Cant Afford Six Weeks | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Executives can’t take 6 weeks off for TMS. SAINT TMS delivers treatment in 5 days. Learn about the accelerated option in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content:
            "The Executive Who Cant Afford Six Weeks | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Executives can’t take 6 weeks off for TMS. SAINT TMS delivers treatment in 5 days. Learn about the accelerated option in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/the-executive-who-cant-afford-six-weeks",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/the-executive-who-cant-afford-six-weeks",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <ExecutiveCantAffordSixWeeks />;
}
